import { render, staticRenderFns } from "./VentasPendientesDeAprobacion.vue?vue&type=template&id=10b9045a&"
import script from "./VentasPendientesDeAprobacion.vue?vue&type=script&lang=js&"
export * from "./VentasPendientesDeAprobacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports